import script from "./PlayerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerDialog.vue?vue&type=script&setup=true&lang=js"

import "./PlayerDialog.vue?vue&type=style&index=0&id=65456e4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65456e4a"]])

export default __exports__